import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/constants";
import useSeo from "@/lib/useSeo";

export default function Datenschutz() {
    useSeo({
        title: "Datenschutz – Alpen Reinigung Innsbruck",
        description:
            "Datenschutzerklärung von Alpen Reinigung. Informationen zur Verarbeitung Ihrer Daten gemäß DSGVO bei Kontaktanfragen.",
        path: "/datenschutz",
    });
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
            <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-[#C9D3E1] hover:text-white mb-8"
            >
                <ArrowLeft className="h-4 w-4" />
                Zurück zur Startseite
            </Link>
            <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#7BD3FF]">
                Rechtliches
            </p>
            <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                Datenschutzerklärung
            </h1>
            <div className="mt-8 space-y-6 text-[#C9D3E1] leading-relaxed">
                <p>
                    Wir nehmen den Schutz Ihrer persönlichen Daten ernst und behandeln
                    sie gemäß der Datenschutzgrundverordnung (DSGVO) sowie dem
                    österreichischen Datenschutzgesetz (DSG) vertraulich.
                </p>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        1. Verantwortlich
                    </h2>
                    <p>
                        {COMPANY.legalName}, {COMPANY.address.street},{" "}
                        {COMPANY.address.city}
                        <br />
                        Telefon: {COMPANY.phone} · E-Mail: {COMPANY.email}
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        2. Verarbeitete Daten
                    </h2>
                    <p>
                        Bei einer Kontaktanfrage über unsere Website erheben wir die von
                        Ihnen übermittelten Daten (Name, E-Mail-Adresse, optional
                        Telefonnummer, gewünschte Leistung sowie Inhalt Ihrer
                        Nachricht). Diese Daten werden ausschließlich zur Bearbeitung
                        Ihrer Anfrage verwendet.
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        3. Rechtsgrundlage
                    </h2>
                    <p>
                        Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b
                        DSGVO (Anbahnung eines Vertrags) bzw. Art. 6 Abs. 1 lit. f DSGVO
                        (berechtigtes Interesse, Anfragen zu beantworten).
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        4. Speicherdauer
                    </h2>
                    <p>
                        Wir speichern Ihre Daten so lange, wie es für die Bearbeitung
                        Ihrer Anfrage und etwaige Folgeprozesse erforderlich ist. Im
                        Anschluss werden die Daten gelöscht, sofern keine gesetzlichen
                        Aufbewahrungspflichten entgegenstehen.
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        5. Empfänger / Auftragsverarbeiter
                    </h2>
                    <p>
                        Zur Zustellung der Anfragen per E-Mail nutzen wir den Anbieter
                        Resend (Resend, Inc.). Hosting erfolgt bei einem
                        EU-/europäischen Anbieter. Mit allen Auftragsverarbeitern
                        bestehen Verträge gemäß Art. 28 DSGVO.
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        6. Cookies
                    </h2>
                    <p>
                        Details zur Cookie-Nutzung finden Sie in unserer{" "}
                        <Link
                            to="/cookie-policy"
                            className="text-[#7BD3FF] hover:text-white underline underline-offset-2"
                        >
                            Cookie-Policy
                        </Link>
                        .
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        7. Ihre Rechte
                    </h2>
                    <p>
                        Sie haben das Recht auf Auskunft, Berichtigung, Löschung,
                        Einschränkung der Verarbeitung, Datenportabilität sowie
                        Widerspruch. Wenden Sie sich dafür an{" "}
                        <a
                            href={`mailto:${COMPANY.email}`}
                            className="text-[#7BD3FF] hover:text-white underline underline-offset-2"
                        >
                            {COMPANY.email}
                        </a>
                        . Beschwerden können Sie bei der österreichischen
                        Datenschutzbehörde einbringen.
                    </p>
                </section>
            </div>
        </div>
    );
}
